var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.event.questions.length > 0)?_c('a',{staticClass:"Button Button--green-outline PreviewWebForm",attrs:{"href":_vm.event.preview_url,"target":"_blank","rel":"noreferrer noopener","title":"Preview the event based on the last time it was updated."}},[_vm._v("Preview "),_c('span',{staticClass:"Icon-s Icon-eye"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }